var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { xml2json } from 'xml-js';
function transform(xmlStr) {
    var json = xml2json(xmlStr, { compact: true });
    return JSON.parse(json);
}
function common_ui_trans(json) {
    var userInputs = json.userInputs;
    var allActions = new Set();
    var allConditions = new Set();
    var dict = {};
    userInputs.userInput.forEach(function (userInput) {
        var _attributes = userInput._attributes, action = userInput.action, label = userInput.label, userData = userInput.userData, conditions = userInput.conditions, description = userInput.description, safety = userInput.safety;
        allActions.add(action._text);
        if (conditions) {
            var a = Array.isArray(conditions) ? conditions : [conditions];
            a.forEach(function (_a) {
                var condition = _a.condition;
                return allConditions.add(condition._text);
            });
        }
        dict[_attributes.name] = {
            action: action._text,
            label: label._text,
            userData: userData._text,
            name: _attributes.name,
            id: _attributes.id,
            description: description,
            safety: safety,
        };
    });
    console.log('all actions', Array.from(allActions));
    console.log('all conditions', Array.from(allConditions));
    return dict;
}
function common_uis_types_trans(json) {
    var userInputSetTypes = json.userInputSets.userInputSetTypes;
    var dict = {};
    var arr = Array.isArray(userInputSetTypes.userInputSetType)
        ? userInputSetTypes.userInputSetType
        : [userInputSetTypes.userInputSetType];
    arr.forEach(function (userInputSetType) {
        var _attributes = userInputSetType._attributes;
        if (dict[_attributes.name]) {
            console.warn('Duplicate name found in common_uis_types for name', _attributes.name);
        }
        dict[_attributes.name] = {
            name: _attributes.name,
            length: _attributes.length,
            default: _attributes.default,
        };
    });
    return dict;
}
function common_uis_trans(json) {
    var userInputSet = json.userInputSets.userInputSet;
    var dict = {};
    userInputSet.forEach(function (userInputSet) {
        var userInputSlot = userInputSet.userInputSlots.userInputSlot, _attributes = userInputSet._attributes;
        if (!userInputSlot) {
            return;
        }
        var arr = Array.isArray(userInputSlot) ? userInputSlot : [userInputSlot];
        if (dict[_attributes.name]) {
            console.warn('Duplicate name found in common_uis for name', _attributes.name);
        }
        dict[_attributes.name] = {
            name: _attributes.name,
            type: _attributes.type,
            buttons: arr.map(function (_a) {
                var _attributes = _a._attributes;
                return ({
                    name: _attributes.name,
                    pos: _attributes.pos,
                });
            }),
        };
    });
    return dict;
}
export var transformTouchPanelDefinition = function (_a) {
    var buttons = _a.buttons, groups = _a.groups, defaults = _a.defaults;
    return ({
        common_ui: __assign({}, buttons.reduce(function (acc, item) { return (__assign(__assign({}, acc), common_ui_trans(transform(item)))); }, {})),
        common_uis: __assign({}, groups.reduce(function (acc, item) { return (__assign(__assign({}, acc), common_uis_trans(transform(item)))); }, {})),
        common_uis_types: __assign({}, defaults.reduce(function (acc, item) { return (__assign(__assign({}, acc), common_uis_types_trans(transform(item)))); }, {})),
    });
};
//# sourceMappingURL=transform.js.map